var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          attrs: { type: "infor", size: "small" },
          on: { click: _vm.showDialog }
        },
        [_vm._v("\n    显示字段配置\n  ")]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.show, title: "显示字段设置" },
          on: {
            "update:visible": function($event) {
              _vm.show = $event
            }
          }
        },
        [
          "" + _vm.page === "1"
            ? _c(
                "div",
                { staticClass: "_dialog_container_box" },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      staticStyle: { "margin-left": "30px" },
                      model: {
                        value: _vm.form[_vm.page].user_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "user_id", $$v)
                        },
                        expression: "form[page].user_id"
                      }
                    },
                    [_vm._v("\n        用户id\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].consignee,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "consignee", $$v)
                        },
                        expression: "form[page].consignee"
                      }
                    },
                    [_vm._v("\n        收货人姓名\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].wave_picking_mobile_hide,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_mobile_hide",
                            $$v
                          )
                        },
                        expression: "form[page].wave_picking_mobile_hide"
                      }
                    },
                    [_vm._v("\n        收货人手机\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].address,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "address", $$v)
                        },
                        expression: "form[page].address"
                      }
                    },
                    [_vm._v("\n        收货人地址\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].wave_picking_full_allot,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_full_allot",
                            $$v
                          )
                        },
                        expression: "form[page].wave_picking_full_allot"
                      }
                    },
                    [_vm._v("\n        是否配齐\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].shipping_company,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "shipping_company", $$v)
                        },
                        expression: "form[page].shipping_company"
                      }
                    },
                    [_vm._v("\n        快递公司\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].shipping_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "shipping_num", $$v)
                        },
                        expression: "form[page].shipping_num"
                      }
                    },
                    [_vm._v("\n        快递单号\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value:
                          _vm.form[_vm.page].wave_picking_is_put_picking_list,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_is_put_picking_list",
                            $$v
                          )
                        },
                        expression:
                          "form[page].wave_picking_is_put_picking_list"
                      }
                    },
                    [_vm._v("是否放置配货单\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value:
                          _vm.form[_vm.page]
                            .wave_picking_is_generate_picking_task,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_is_generate_picking_task",
                            $$v
                          )
                        },
                        expression:
                          "form[page].wave_picking_is_generate_picking_task"
                      }
                    },
                    [_vm._v("是否生成拣货任务\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].custom_note,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "custom_note", $$v)
                        },
                        expression: "form[page].custom_note"
                      }
                    },
                    [_vm._v("\n        用户备注\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].admin_note,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "admin_note", $$v)
                        },
                        expression: "form[page].admin_note"
                      }
                    },
                    [_vm._v("\n        客服备注\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].ck_remark,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "ck_remark", $$v)
                        },
                        expression: "form[page].ck_remark"
                      }
                    },
                    [_vm._v("\n        仓库备注\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].wave_picking_picking_type,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_picking_type",
                            $$v
                          )
                        },
                        expression: "form[page].wave_picking_picking_type"
                      }
                    },
                    [_vm._v("\n        拣货方式\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].wave_picking_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "wave_picking_num", $$v)
                        },
                        expression: "form[page].wave_picking_num"
                      }
                    },
                    [_vm._v("\n        待发货商品数量\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].weight,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "weight", $$v)
                        },
                        expression: "form[page].weight"
                      }
                    },
                    [_vm._v("\n        实际重量\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].wave_picking_print_status,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_print_status",
                            $$v
                          )
                        },
                        expression: "form[page].wave_picking_print_status"
                      }
                    },
                    [_vm._v("\n        面单状态\n      ")]
                  ),
                  _vm._v(" "),
                  "" + _vm.page === "1"
                    ? _c(
                        "el-checkbox",
                        {
                          staticClass: "_item",
                          model: {
                            value: _vm.form[_vm.page].wave_picking_pay_way,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form[_vm.page],
                                "wave_picking_pay_way",
                                $$v
                              )
                            },
                            expression: "form[page].wave_picking_pay_way"
                          }
                        },
                        [_vm._v("\n        支付方式\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].order_sn,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "order_sn", $$v)
                        },
                        expression: "form[page].order_sn"
                      }
                    },
                    [_vm._v("\n        订单号\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].create_time,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "create_time", $$v)
                        },
                        expression: "form[page].create_time"
                      }
                    },
                    [_vm._v("\n        波次生成时间\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].wave_picking_is_stop_shipping,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_is_stop_shipping",
                            $$v
                          )
                        },
                        expression: "form[page].wave_picking_is_stop_shipping"
                      }
                    },
                    [_vm._v("\n        是否拦截\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].update_time,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "update_time", $$v)
                        },
                        expression: "form[page].update_time"
                      }
                    },
                    [_vm._v("\n        更新时间\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].sk_time,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "sk_time", $$v)
                        },
                        expression: "form[page].sk_time"
                      }
                    },
                    [_vm._v("\n        最近物流时间\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].sk_content,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "sk_content", $$v)
                        },
                        expression: "form[page].sk_content"
                      }
                    },
                    [_vm._v("\n        最近物流信息\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].shipping_kdniao_state,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "shipping_kdniao_state",
                            $$v
                          )
                        },
                        expression: "form[page].shipping_kdniao_state"
                      }
                    },
                    [_vm._v("\n        物流状态\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].wave_picking_is_stock,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_is_stock",
                            $$v
                          )
                        },
                        expression: "form[page].wave_picking_is_stock"
                      }
                    },
                    [_vm._v("\n        是否囤货\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value:
                          _vm.form[_vm.page].wave_picking_ext_same_day_shipping,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_ext_same_day_shipping",
                            $$v
                          )
                        },
                        expression:
                          "form[page].wave_picking_ext_same_day_shipping"
                      }
                    },
                    [_vm._v("\n        是否即日发\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].is_delivery_formal,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "is_delivery_formal",
                            $$v
                          )
                        },
                        expression: "form[page].is_delivery_formal"
                      }
                    },
                    [_vm._v("\n        是否催发\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].pre_weight,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "pre_weight", $$v)
                        },
                        expression: "form[page].pre_weight"
                      }
                    },
                    [_vm._v("\n        计算重量\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].guarantee_value_formal,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "guarantee_value_formal",
                            $$v
                          )
                        },
                        expression: "form[page].guarantee_value_formal"
                      }
                    },
                    [_vm._v("\n        是否保价\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          "" + _vm.page === "2"
            ? _c(
                "div",
                { staticClass: "_dialog_container_box" },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      staticStyle: { "margin-left": "30px" },
                      model: {
                        value: _vm.form[_vm.page].user_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "user_id", $$v)
                        },
                        expression: "form[page].user_id"
                      }
                    },
                    [_vm._v("用户id\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].consignee,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "consignee", $$v)
                        },
                        expression: "form[page].consignee"
                      }
                    },
                    [_vm._v("\n        收货人姓名\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].wave_picking_full_allot,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_full_allot",
                            $$v
                          )
                        },
                        expression: "form[page].wave_picking_full_allot"
                      }
                    },
                    [_vm._v("\n        是否配齐\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].wave_picking_mobile_hide,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_mobile_hide",
                            $$v
                          )
                        },
                        expression: "form[page].wave_picking_mobile_hide"
                      }
                    },
                    [_vm._v("\n        收货人手机\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].address,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "address", $$v)
                        },
                        expression: "form[page].address"
                      }
                    },
                    [_vm._v("\n        收货人地址\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].shipping_company,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "shipping_company", $$v)
                        },
                        expression: "form[page].shipping_company"
                      }
                    },
                    [_vm._v("\n        快递公司\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value:
                          _vm.form[_vm.page].wave_picking_is_put_picking_list,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_is_put_picking_list",
                            $$v
                          )
                        },
                        expression:
                          "form[page].wave_picking_is_put_picking_list"
                      }
                    },
                    [_vm._v("\n        是否放置配货单\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value:
                          _vm.form[_vm.page]
                            .wave_picking_is_generate_picking_task,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_is_generate_picking_task",
                            $$v
                          )
                        },
                        expression:
                          "form[page].wave_picking_is_generate_picking_task"
                      }
                    },
                    [_vm._v("\n        是否生成拣货任务\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].wave_picking_picking_type,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_picking_type",
                            $$v
                          )
                        },
                        expression: "form[page].wave_picking_picking_type"
                      }
                    },
                    [_vm._v("\n        拣货方式\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].shipping_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "shipping_num", $$v)
                        },
                        expression: "form[page].shipping_num"
                      }
                    },
                    [_vm._v("\n        快递单号\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].wave_picking_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "wave_picking_num", $$v)
                        },
                        expression: "form[page].wave_picking_num"
                      }
                    },
                    [_vm._v("\n        待发总件数\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].weight,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "weight", $$v)
                        },
                        expression: "form[page].weight"
                      }
                    },
                    [_vm._v("\n        实际重量\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].wave_picking_print_status,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "wave_picking_print_status",
                            $$v
                          )
                        },
                        expression: "form[page].wave_picking_print_status"
                      }
                    },
                    [_vm._v("\n        面单状态\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].work_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "work_id", $$v)
                        },
                        expression: "form[page].work_id"
                      }
                    },
                    [_vm._v("\n        工单id\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].problem_name,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "problem_name", $$v)
                        },
                        expression: "form[page].problem_name"
                      }
                    },
                    [_vm._v("\n        原工单问题\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].problem_desc,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "problem_desc", $$v)
                        },
                        expression: "form[page].problem_desc"
                      }
                    },
                    [_vm._v("\n        问题描述\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].service_desc,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "service_desc", $$v)
                        },
                        expression: "form[page].service_desc"
                      }
                    },
                    [_vm._v("\n        客服备注\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].word_dbid_blp_note,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "word_dbid_blp_note",
                            $$v
                          )
                        },
                        expression: "form[page].word_dbid_blp_note"
                      }
                    },
                    [_vm._v("\n        拆包备注\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].create_time,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "create_time", $$v)
                        },
                        expression: "form[page].create_time"
                      }
                    },
                    [_vm._v("\n        波次时间\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].update_time,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "update_time", $$v)
                        },
                        expression: "form[page].update_time"
                      }
                    },
                    [_vm._v("\n        更新时间\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].sk_time,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "sk_time", $$v)
                        },
                        expression: "form[page].sk_time"
                      }
                    },
                    [_vm._v("\n        最近物流时间\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].sk_content,
                        callback: function($$v) {
                          _vm.$set(_vm.form[_vm.page], "sk_content", $$v)
                        },
                        expression: "form[page].sk_content"
                      }
                    },
                    [_vm._v("\n        最近物流信息\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].shipping_kdniao_state,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "shipping_kdniao_state",
                            $$v
                          )
                        },
                        expression: "form[page].shipping_kdniao_state"
                      }
                    },
                    [_vm._v("\n        物流状态\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "_item",
                      model: {
                        value: _vm.form[_vm.page].guarantee_value_formal,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form[_vm.page],
                            "guarantee_value_formal",
                            $$v
                          )
                        },
                        expression: "form[page].guarantee_value_formal"
                      }
                    },
                    [_vm._v("\n        是否保价\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toSave } },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "info" },
                  on: {
                    click: function($event) {
                      _vm.show = false
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cd13174", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cd13174","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/components/fieldSetting.vue
// module id = null
// module chunks = 